module.exports = __webpack_public_path__ + "img/no_product_image_450.5f6ee4fe.jpg";